export const UpTriangle = ({ size }: { size?: 'small' | 'large' }) => (
  <div
    className={`size-0 ${
      size === 'small'
        ? 'border-x-4 border-b-[6.92px]'
        : 'border-x-[5px] border-b-[8.65px]'
    } border-x-transparent border-b-th-up`}
  />
)

export const DownTriangle = ({ size }: { size?: 'small' | 'large' }) => (
  <div
    className={`size-0 ${
      size === 'small'
        ? 'border-x-4 border-t-[6.92px]'
        : 'border-x-[5px] border-t-[8.65px]'
    } border-x-transparent border-t-th-down`}
  />
)
